"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminableFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var AdminableFactory = /** @class */ (function (_super) {
    __extends(AdminableFactory, _super);
    function AdminableFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    AdminableFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    AdminableFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    AdminableFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    AdminableFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    AdminableFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return AdminableFactory;
}(contracts_1.ContractFactory));
exports.AdminableFactory = AdminableFactory;
var _abi = [
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b5060b38061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c80636e9960c314602d575b600080fd5b6033604f565b6040516001600160a01b03909116815260200160405180910390f35b600060787fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d61035490565b91905056fea2646970667358221220d5a2d3de16cfa9adb93d91bbe54276d5dc7ad27f126992469551dbc23867c94f64736f6c63430008040033";
